import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";

import { MobileCreateCaseWizardContainer } from "./MobileCreateCaseWizardContainer";

export function MobileCreateCaseWizardPage() {
  return (
    <BerlinThemeProvider fullHeight>
      <MobileCreateCaseWizardContainer />
    </BerlinThemeProvider>
  );
}
